<script>
	import TripadvisorAward from '$lib/components/TripadvisorAward.svelte';
	import * as Carousel from '$lib/components/ui/carousel';
	import * as Card from '$lib/components/ui/card';
	import { ArrowRight, Star } from 'lucide-svelte';
</script>

<section class="mx-auto flex max-w-7xl flex-col px-4 pb-20 pt-12 lg:pt-20">
	<h2
		class="scroll-m-20 pb-2 font-heading text-2xl font-semibold tracking-tight transition-colors first:mt-0 lg:text-3xl"
	>
		Don't take our word for it, hear from our adventurers
	</h2>
	<div class="mx-auto mt-6 w-full max-w-7xl pb-12 lg:mt-12">
		<div class="group col-span-1 flex w-full flex-col">
			<div
				class="relative flex overflow-hidden rounded-2xl bg-gray-900 px-6 pb-32 pt-12 shadow-xl sm:px-10 md:px-12 lg:h-[350px] lg:items-center lg:rounded-3xl lg:px-20 lg:py-20"
			>
				<enhanced:img
					class="absolute inset-0 h-full w-full object-cover"
					src="/src/lib/assets/images/cradle-mountain.jpg"
					alt="Thousands of 5 star reviews and counting"
					loading="lazy"
				/>
				<div class="absolute inset-0 bg-foreground/40 mix-blend-multiply transition-all"></div>

				<div class="relative mx-auto max-w-xl lg:mx-0">
					<h3
						class="text-center font-heading text-2xl font-bold text-background lg:text-left lg:text-4xl"
					>
						2 000+ 5 star reviews and counting
					</h3>
				</div>
			</div>
		</div>
		<div class="mx-auto grid-cols-4 lg:grid">
			<div class="col-span-1 hidden flex-col pt-4 lg:flex">
				<!-- w-44 lines the Tassie Specialist badge up with the award row under the carousel -->
				<TripadvisorAward class="w-44" />
				<enhanced:img
					src="/src/lib/assets/images/tassie-specialist.png"
					alt="Tassie Specialist Award Winner"
					class="ml-8 mt-4 w-36"
					loading="lazy"
				/>
			</div>
			<div class="col-span-3 -mt-24 px-8 lg:px-0 lg:pr-12">
				<Carousel.Root class="w-full" opts={{ align: 'start' }}>
					<Carousel.Content peek>
						<Carousel.Item class="basis-[85%] lg:basis-1/3">
							<div class="w-full text-left">
								<Card.Root class="w-full overflow-hidden rounded-2xl border-none shadow-none bg-muted">
									<Card.Header class="relative w-full ">
										<div class="flex gap-0">
											<Star class="fill-tt-red text-tt-red" />
											<Star class="fill-tt-red text-tt-red" />
											<Star class="fill-tt-red text-tt-red" />
											<Star class="fill-tt-red text-tt-red" />
											<Star class="fill-tt-red text-tt-red" />
										</div>
										<Card.Title class="h-14 line-clamp-2 font-heading text-lg leading-snug"
											>We had fantastic trip to Bruny Island with Tassie Tours!!</Card.Title
										>
										<Card.Description class="  ">Lottie S</Card.Description>
									</Card.Header>
									<Card.Content class="grid  gap-4">
										<div>
											<p class="h-48">
												The tour was smoothly run with our highly knowledgeable guide Jodi! She was
												an absolute legend! We will recommend this tour to our friends back in
												Adelaide and we can't wait to visit and join another tour in the future!
											</p>
										</div>
									</Card.Content>
								</Card.Root>
							</div>
						</Carousel.Item>
						<Carousel.Item class="basis-[85%] lg:basis-1/3">
							<div class="w-full text-left">
								<Card.Root class="w-full overflow-hidden rounded-2xl border-none shadow-none bg-muted">
									<Card.Header class="relative w-full ">
										<div class="flex gap-0">
											<Star class="fill-tt-red text-tt-red" />
											<Star class="fill-tt-red text-tt-red" />
											<Star class="fill-tt-red text-tt-red" />
											<Star class="fill-tt-red text-tt-red" />
											<Star class="fill-tt-red text-tt-red" />
										</div>
										<Card.Title class="h-14 line-clamp-2 font-heading text-lg leading-snug"
											>Tassie Tours! Just awesome full stop.</Card.Title
										>
										<Card.Description class="  ">Carl L</Card.Description>
									</Card.Header>
									<Card.Content class="grid  gap-4">
										<div class="relative">
											<p class="h-48">
												Arrived in the wonderful city of Hobart yesterday on a cruise. Wanted to
												travel to Port Arthur and check it out, stepped off the ship and found this
												company. Super simple, great advice even gave a Veteran Discount. Our tour
												guide “Tilly” was amazing we went to other great places to and from Port
												Arthur. Thanks to Tilly, we are definitely inspired to come back in the near
												future with the camper and travel around Tasmanian. Wonderful place, down to
												earth. 100% recommend Tassie Tours.
											</p>
											<div
												class="absolute -bottom-6 h-12 w-full bg-gradient-to-t from-muted to-transparent"
											></div>
										</div>
									</Card.Content>
								</Card.Root>
							</div>
						</Carousel.Item>
						<Carousel.Item class="basis-[85%] lg:basis-1/3">
							<div class="w-full text-left">
								<Card.Root class="w-full overflow-hidden rounded-2xl border-none shadow-none bg-muted">
									<Card.Header class="relative w-full ">
										<div class="flex gap-0">
											<Star class="fill-tt-red text-tt-red" />
											<Star class="fill-tt-red text-tt-red" />
											<Star class="fill-tt-red text-tt-red" />
											<Star class="fill-tt-red text-tt-red" />
											<Star class="fill-tt-red text-tt-red" />
										</div>
										<Card.Title class="h-14 line-clamp-2 font-heading text-lg leading-snug"
											>This was one of the highlights of our three week vacation</Card.Title
										>
										<Card.Description class="  ">Marilyn P</Card.Description>
									</Card.Header>
									<Card.Content class="grid  gap-4">
										<div class="relative">
											<p class="h-48">
												Our host, Nathan was friendly, funny and knowledgeable. We got beautiful
												pictures of some phenomenal places. The beaches are spectacular, the rain
												forrest exquisite. We stopped for oysters and they were fresh and some of
												the best I've ever had. You won't be disappointed .
											</p>
											<div
												class="absolute -bottom-6 h-12 w-full bg-gradient-to-t from-muted to-transparent"
											></div>
										</div>
									</Card.Content>
								</Card.Root>
							</div>
						</Carousel.Item>
						<Carousel.Item class="basis-[85%] lg:basis-1/3">
							<div class="w-full text-left">
								<Card.Root class="w-full overflow-hidden rounded-2xl border-none shadow-none bg-muted">
									<Card.Header class="relative w-full ">
										<div class="flex gap-0">
											<Star class="fill-tt-red text-tt-red" />
											<Star class="fill-tt-red text-tt-red" />
											<Star class="fill-tt-red text-tt-red" />
											<Star class="fill-tt-red text-tt-red" />
											<Star class="fill-tt-red text-tt-red" />
										</div>
										<Card.Title class="h-14 line-clamp-2 font-heading text-lg leading-snug"
											>We had fantastic trip to Bruny Island with Tassie Tours!!</Card.Title
										>
										<Card.Description class="  ">Lottie S</Card.Description>
									</Card.Header>
									<Card.Content class="grid  gap-4">
										<div>
											<p class="h-48">
												The tour was smoothly run with our highly knowledgeable guide Jodi! She was
												an absolute legend! We will recommend this tour to our friends back in
												Adelaide and we can't wait to visit and join another tour in the future!
											</p>
										</div>
									</Card.Content>
								</Card.Root>
							</div>
						</Carousel.Item>
					</Carousel.Content>
					<Carousel.Previous class="hidden lg:flex" />
					<Carousel.Next class="hidden lg:flex" />
				</Carousel.Root>
				<div class="mt-10 flex flex-wrap items-center justify-center gap-x-10 gap-y-6 lg:justify-start">
					<enhanced:img
						src="/src/lib/assets/images/awards/atec-tourism-export-awards-finalist-2026.png"
						alt="ATEC Tourism Export Awards Finalist 2026"
						class="h-24 w-auto lg:h-28"
						loading="lazy"
					/>
					<enhanced:img
						src="/src/lib/assets/images/awards/tasmanian-tourism-awards-peoples-choice-finalist-2026.png"
						alt="Tasmanian Tourism Awards 2026 Finalist - People's Choice Award"
						class="h-24 w-auto lg:h-28"
						loading="lazy"
					/>
				</div>
			</div>
		</div>
	</div>
</section>
